module.exports = __webpack_public_path__ + "static/media/user.6f69337c.svg";